<template>
  <div class="main">
    <div class="main-top">
      <div class="main-top-title">玩转线上活动</div>
      <div class="main-top-card">
        <div class="main-card-item">
          <div class="main-card-item-left">
            <img
              class="card-item-left-img"
              src="@/assets/images/icon_createactivity@2x.png"
            />
          </div>
          <div class="main-card-item-right">
            <div class="card-item-title">创建活动及活动配置</div>
            <div class="card-item-desc">
              血压、睡眠、步数等健康监测任务以及每日打卡等多模式配置
            </div>
            <div class="creat-btn">
              <span @click="creatActive">去创建</span>
            </div>
          </div>
        </div>
        <div class="main-card-item">
          <div class="main-card-item-left">
            <img
              class="card-item-left-img"
              src="@/assets/images/icon_h5link@2x.png"
            />
          </div>
          <div class="main-card-item-right">
            <div class="card-item-title">多端支持H5活动链接</div>
            <div class="card-item-desc">
              包含健康检测及每日打卡任务的标准活动，复制链接在手机查看
            </div>
            <div
              class="creat-btn"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
              v-clipboard:copy="textToCopy"
              style="cursor: pointer"
            >
              复制链接
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-space">
      <div class="main-space-top">
        <div
          class="main-space-top-card"
          :style="{ background: activeIndex === 1 ? '#F4F9FF' : '' }"
          @click="chooseActive(1)"
        >
          <div
            class="main-card-num"
            :style="{ color: activeIndex === 1 ? '#165dff' : '' }"
          >
            {{ activeNum?.inProgress || 0 }}
          </div>
          <div class="main-card-label">进行中活动</div>
          <div
            class="active-line"
            :style="{ background: activeIndex === 1 ? '#165dff' : '' }"
          ></div>
        </div>
        <div
          class="main-space-top-card"
          :style="{ background: activeIndex === 2 ? '#F4F9FF' : '' }"
          @click="chooseActive(2)"
        >
          <div
            class="main-card-num"
            :style="{ color: activeIndex === 2 ? '#165dff' : '' }"
          >
            {{ activeNum?.notStarted || 0 }}
          </div>
          <div class="main-card-label">未开始活动</div>
          <div
            class="active-line"
            :style="{ background: activeIndex === 2 ? '#165dff' : '' }"
          ></div>
        </div>
        <div
          class="main-space-top-card"
          :style="{ background: activeIndex === 3 ? '#F4F9FF' : '' }"
          @click="chooseActive(3)"
        >
          <div
            class="main-card-num"
            :style="{ color: activeIndex === 3 ? '#165dff' : '' }"
          >
            {{ activeNum?.ended || 0 }}
          </div>
          <div class="main-card-label">已结束活动</div>
          <div
            class="active-line"
            :style="{ background: activeIndex === 3 ? '#165dff' : '' }"
          ></div>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          align="center"
          prop="code"
          label="活动编号"
          width="150"
        >
          <template slot-scope="scope">
            <div
              style="color: #165dff; cursor: pointer"
              @click="toDetail(scope.row)"
            >
              {{ scope.row.code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="subtitle" label="活动名称">
          <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="top"
              popper-class="custom-popover"
            >
              <div slot="reference" class="submitted">
                {{ scope.row.subtitle || "--" }}
              </div>
              <div
                style="
                  display: flex;
                  text-overflow: ellipsis;
                  white-space: pre-line;
                  justify-content: center;
                "
              >
                {{ scope.row.subtitle || "--" }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="type" label="活动类型" width="80">
          <template slot-scope="scope">
            <div>{{ activeTypeList[scope.row.type] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="targetDays"
          label="打卡天数"
          width="80"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTimeString"
          label="活动开始时间"
          width="180"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row?.stime.slice(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTimeString"
          label="活动结束时间"
          width="180"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row?.etime.slice(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <div class="status-point-box">
              <span
                class="status-point"
                :style="{
                  backgroundColor: activeStatusColor[scope.row.status],
                }"
              ></span
              ><span>{{ activeStatusList[scope.row.status] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createdAt"
          label="创建时间"
          width="180"
        ></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-permission="'update_user_role'"
              @click="toDetail(scope.row)"
              type="text"
              size="small"
            >
              查看详情
            </el-button>
            <el-button @click="handleCopy(scope.row)" type="text" size="small">
              活动链接
            </el-button>
            <el-button
              @click="copySearchLink(scope.row)"
              type="text"
              size="small"
            >
              查询链接
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" style="margin-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="currentChangefn"
          layout="->,sizes,total,prev, pager, next, jumper"
          :current-page="page"
          :page-sizes="[5, 10, 20, 50, 100]"
          :total="total"
          :page-size="size"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      activeIndex: 1,
      activeNum: {},
      activeTypeList: {
        1: "再得一台",
        2: "退还全款",
        3: "全额奖励",
        4: "卖三赠一",
        5: "礼品奖励",
      },
      activeStatusList: {
        1: "未开始",
        2: "进行中",
        3: "已结束",
      },
      activeStatusColor: {
        1: "#00B42A",
        2: "#165DFF",
        3: "#C9CDD4",
      },
      textToCopy: "https://www.yanhezhineng.com/yhe07go.html",
    };
  },
  computed: {},
  created() {
    this.getAcitveNum();
    this.getActiveList();
  },
  methods: {
    handleCopy(row) {
      this.copyActiveLink(row); // 调用复制函数
    },
    copyActiveLink(val) {
      let link = val?.url;
      if (!link) {
        this.$message.error("未配置活动地址");
        return "";
      }
      // link = link + `?code=${val.code}`;
      this.$copyText(link)
        .then(() => this.$message.success("复制成功"))
        .catch(() => this.$message.error("复制失败"));
    },
    async copySearchLink(val) {
      const link = `https://www.yanhezhineng.com/search.html?code=${val.code}`;
      this.$copyText(link)
        .then(() => this.$message.success("复制成功"))
        .catch(() => this.$message.error("复制失败"));
      // try {
      //   await navigator.clipboard.writeText(link);
      //   this.$message.success("复制成功");
      // } catch (err) {
      //   this.$message.error("复制失败");
      // }
    },
    copySuccess() {
      this.$message.success("复制成功");
    },
    copyError() {
      this.$message.error("复制失败");
    },
    async getAcitveNum() {
      const response = await this.$get("/promotion/count/statistics", {});
      if (response.data.code === 1000) {
        this.activeNum = response.data?.data;
      } else {
        this.$message({
          type: "error",
          message: response.data?.msg,
        });
      }
    },
    getActiveList() {
      const statusMap = { 1: 2, 2: 1, 3: 3 };
      const status = statusMap[this.activeIndex] ?? 1;
      this.$get("/promotion/page", {
        page: this.page,
        size: this.size,
        status: status,
      }).then((response) => {
        if (response.data.code === 1000) {
          this.tableData = response.data?.data?.list;
          this.total = response.data?.data?.count;
        } else {
          this.$message({
            type: "error",
            message: response.data?.msg,
          });
        }
      });
    },
    chooseActive(index) {
      // if (this.activeIndex === index) this.activeIndex = 0;
      // else this.activeIndex = index;
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      this.page = 1;
      this.size = 10;
      this.total = 0;
      this.getActiveList();
    },
    creatActive() {
      if (this.$jumpPerm("create_activity")) {
        this.$router.push({
          path: "/activeCreat",
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    currentChangefn(index) {
      console.log(index);
      this.page = index;
      this.getActiveList();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getActiveList();
    },
    toDetail(val) {
      if (this.$jumpPerm("activity_detail")) {
        this.$router.push({
          path: "/activityDetail",
          query: {
            id: val.id,
            targetDays: val.targetDays,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.main {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}
.main-top {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.main-top-title {
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
}
.main-top-card {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 16px;
}
.main-card-item {
  display: flex;
  width: calc(50% - 8px);
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  background-image: url("../../assets/images/pic_bgcard@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.main-card-item-left {
  display: flex;
  // align-items: center;
}
.main-card-item-right {
  display: flex;
  flex-direction: column;
}
.card-item-title {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  margin-bottom: 12px;
}
.card-item-desc {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 32px;
}
.creat-btn {
  font-weight: 400;
  font-size: 14px;
  color: #165dff;
  span {
    cursor: pointer;
  }
}
.card-item-left-img {
  width: 40px;
  height: 40px;
  margin-right: 16px;
}
.main-space {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.main-space-top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  // padding: 16px;
  // box-sizing: border-box;
}
.main-space-top-card {
  display: flex;
  flex-direction: column;
  width: calc((100% - 40px) * 0.3333);
  background: #f7f8fa;
  border-radius: 4px;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  padding: 16px 0px 0px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
}
.main-card-num {
  font-weight: 500;
  font-size: 32px;
  color: #000000;
  line-height: 40px;
  padding-left: 16px;
  box-sizing: border-box;
}
.main-card-label {
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  margin-bottom: 18px;
  padding-left: 16px;
  box-sizing: border-box;
}
.active-line {
  width: 100%;
  height: 6px;
}
.status-point-box {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.status-point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}
.submitted {
  // min-width: 90px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
// ::deep .el-popover {
//   // width: auto !important;
//   display: flex !important;
//   justify-content: center !important;
//   text-align: center !important;
// }
.center-popover .el-popover__content {
  text-align: center;
}
::v-deep .el-popover__reference-wrapper {
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>
